module.exports = "<div id=\"footer\">\n    <a routerLink=\"/legals/cgu\">{{'CGU' | translate}}</a>\n    <a routerLink=\"/legals/legal\">{{'account.legals' | translate}}</a>\n    <a onclick=\"window.dispatchEvent(new Event('TaCOpen', {}))\">{{'account.cookies' | translate}}</a>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/public/public-footer.component.html
// module id = 571
// module chunks = 0